import moment from "moment/moment";

export function currencyFormatter(value, options = {}) {
  const { withSymbol = true, withSign = false, noDecimals = false } = options;
  if (value === null || value === undefined) return null;

  const style = withSymbol ? "currency" : "decimal";
  const signDisplay = withSign ? "exceptZero" : "negative";
  const fractionDigits = noDecimals ? 0 : 2;

  try {
    return formatCurrency(value, style, signDisplay, fractionDigits);
  } catch {
    return formatCurrency(value, style, "auto", fractionDigits);
  }
}

function formatCurrency(value, style, signDisplay, fractionDigits) {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    style,
    currency: "EUR",
    currencyDisplay: "symbol",
    signDisplay,
  });
}

export const dateConvert = (value) => {
  return moment(value).format("DD/MM/YYYY");
};

export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.substring(1);
};

export function formatFileSize(bytes, decimalPoint) {
  if (bytes === 0) return "0 Bytes";
  var k = 1000,
    dm = decimalPoint || 2,
    sizes = ["Octets", "Ko", "Mo", "Go"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
